import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "authentication-layout",
  class: "px-5 py-5 p-lg-0 bg-surface-secondary h-full"
}
const _hoisted_2 = { class: "h-full d-flex justify-content-start" }
const _hoisted_3 = { class: "col-lg-4 p-12 bg-success d-none d-lg-flex flex-column" }
const _hoisted_4 = { class: "mt-20 mb-20" }
const _hoisted_5 = { class: "ls-tight font-bolder display-6 text-white mb-5" }
const _hoisted_6 = { class: "text-white text-opacity-80" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-56 h-56 bg-brand rounded-circle position-absolute bottom-10 transform translate-y-1/2" }, null, -1)
const _hoisted_8 = {
  id: "main",
  class: "w-full"
}
const _hoisted_9 = {
  id: "content",
  class: "h-full d-flex align-items-center flex-column"
}
const _hoisted_10 = { class: "d-flex justify-content-center w-full text-xs align-items-center py-2 mt-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AlertsGroup = _resolveComponent("AlertsGroup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_LogoComponent),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('expressions', 'Authentication_Title'))), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('expressions', 'Authentication_Subtitle'))), 1)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("footer", _hoisted_10, [
              _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$config('AppConfig', 'Name'))), 1),
              _hoisted_11,
              _createVNode(_component_router_link, {
                class: "text-body text-underline",
                to: { name: _ctx.$config('RouteConfig', 'PrivacyPolicyRouteName') }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(
									_ctx.$text('routes_name', 'Route_Privacy_Policy_Name')
								)), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AlertsGroup)
  ], 64))
}